import apiInstance from "@services/Shared/instanceAxios";

const deleteClient = (uuid: string) =>
  apiInstance({
    url: `/clients/${uuid}`,
    method: "delete",
  });

export default deleteClient;
